import React from 'react';
import { Container } from 'reactstrap';
import Footer from './Footer';
import NavMenu from './NavMenu';

interface Props {
    children?: React.ReactNode
};

const Layout = (props: Props) => {
    return (
        <>
            <NavMenu />
            <Container fluid id="main-container">
                {props.children}
            </Container>
            <Footer />
        </>
    );
}

export default Layout;
